import type { ImportRunStatus, ImportRunSummary } from "@/model/interface/DataImport";

export type ImportRecordAction = "CREATED" | "UPDATED";

export const importRecordTags = [
  "Contacts",
  "LeadSummary",
  "Properties",
  "DncEntries",
  "Tasks",
  "Deals",
  "ContactList",
  "ContactListContacts",
  "Tags",
  "Home",
  "CommunicationItems",
  "Imports",
] as const;

export const importStatusPills: Record<ImportRunStatus, { label: string; className: string }> = {
  PENDING: { label: "Queued", className: "status-pill-neutral" },
  RUNNING: { label: "Importing", className: "status-pill-info" },
  COMPLETED: { label: "Completed", className: "status-pill-success" },
  FAILED: { label: "Failed", className: "status-pill-destructive" },
  UNDOING: { label: "Undo queued", className: "status-pill-warning" },
  UNDONE: { label: "Undone", className: "status-pill-neutral" },
};

export function isImportRunActive(run: ImportRunSummary): boolean {
  return run.status === "PENDING" || run.status === "RUNNING" || run.status === "UNDOING";
}

export function importRunKindLabel(run: ImportRunSummary): string {
  switch (run.entityType) {
    case "CONTACT":
      return run.contactType === "LEAD" ? "Leads" : "Contacts";
    case "PROPERTY":
      return "Properties and owners";
    case "DNC":
      return "Do Not Contact";
    case "TASK":
      return "Tasks";
    case "NOTE":
      return "Notes and history";
    default:
      return "Import";
  }
}

export function importRecordsPath(run: ImportRunSummary, action: ImportRecordAction): string | null {
  if (run.entityType !== "CONTACT" && run.entityType !== "PROPERTY") {
    return null;
  }
  const basePath = run.contactType === "LEAD" ? "/leads" : "/contacts/all";
  return `${basePath}?importRunId=${run.id}&importAction=${action}`;
}

export function importDestinationPath(run: ImportRunSummary): string | null {
  switch (run.entityType) {
    case "DNC":
      return "/contacts/dnc";
    case "TASK":
      return "/tasks";
    default:
      return null;
  }
}
